document.addEventListener('DOMContentLoaded', () => {
  const closeButton = document.querySelector('[data-close-cookie]')
  const cookieAttention = document.querySelector('[data-cookie-attention]')
  const cookieLink = document.querySelector('[data-modal-cookie-link]')
  const cookieInfoModal = document.querySelector('[data-modal-cookie]')
  const age = 60 * 60 * 24 * 90

  cookieLink &&
    cookieLink.addEventListener('click', (event) => {
      cookieInfoModal.classList.remove('is-invisible')
      cookieInfoModal.classList.add('is-layout-locked')
    })

  const getCookie = () => {
    return document.cookie.split('; ').reduce((acc, item) => {
      const [name, value] = item.split('=')
      acc[name] = value
      return acc
    }, {})
  }

  const cookie = getCookie()

  if (!cookie.cookieAttention) {
    cookieAttention && cookieAttention.classList.toggle('is-hidden')
  }

  closeButton &&
    closeButton.addEventListener('click', () => {
      cookieAttention.classList.toggle('is-hidden')

      document.cookie = `cookieAttention=close;max-age=${age};path=/`
    })
})
